import { Tab, TabProps } from "@mui/material";
import { useCheckPermission } from "commons/hooks/use-check-permission";
import { observer } from "mobx-react-lite";

type XTabProps = TabProps & {
  accessPermission?: "all" | string[];
};
export const XTab = observer(
  ({ accessPermission = "all", ...props }: XTabProps) => {
    const { allowAccess } = useCheckPermission(accessPermission);
    return (
      <Tab
        {...props}
        disabled={!allowAccess}
        sx={{ ...props.sx, textTransform: "capitalize", padding: "5px 15px" }}
        iconPosition="start"
      />
    );
  }
);
